import { registerPlugins } from '@/plugins'
import { createApp } from 'vue'
import 'vue3-tour/dist/vue3-tour.css'
import { createAppRouter } from '@/router/common.js'
import App from '@/SiteRoot.vue'
import commonFormatters from '@/services/common-formatters.js'
import commonIDBEntities from '@/services/common-idb-entities.js'
import defaultVars from '@/theme/vars.js'
import { createLightTheme } from '@/theme/light'
import { createDarkTheme } from '@/theme/dark'
import { log } from '@/services/log'

export default async function start(
  appStorePromise,
  routes,
  formatters = {},
  menuOptions = [],
  entities = [],
  vars = { light: {}, dark: {} },
  client = ''
) {
  log(`ᛋᛣᚢᚢᛚᛞ Starting Vue application for ${client}`)
  const app = createApp(App)
  const appStoreFn = (await appStorePromise).useAppStore
  const lightVars = { ...defaultVars, ...vars.light }
  const darkVars = { ...defaultVars, ...vars.dark }
  app.provide('formatters', { ...commonFormatters, ...formatters })
  app.provide('menuOptions', menuOptions)
  app.provide('appStoreFn', appStoreFn)
  app.provide('lightThemeOverrides', createLightTheme(lightVars))
  app.provide('darkThemeOverrides', createDarkTheme(darkVars))
  const idbEntities = [...commonIDBEntities, ...entities]
  const router = createAppRouter(routes)
  registerPlugins(app, router, appStoreFn, idbEntities)
  app.mount('#app')
}
